import { createSlice } from "@reduxjs/toolkit"
import { formatDate } from "helpers/functions"

const app = createSlice({
  name: "app",
  initialState: {
    loading: false,
    message: {
      text: "",
      variant: ""
    },
    isLoggedIn: false,
    filters: {
      date: formatDate(new Date()),
      restaurant: "ALL",
      period: "4",
      searchField: "",
      metrics: ["ALL"],
      alcohol_type: "All",
      giftCard_type: "All",
      rank: [],
      category: [],
      weeks: {},
      userType: "active_users",
      startDate2: "",
      endDate2: "",
      isCompare: false
    },
    restaurantList: [],
    userTypeList: [],
    adminUsersList: [],
    roleUsers: [],
    newRestaurantList: [],
    isLoading: false,
    isUpdating: false,
    isMultiRestaurant: false
  },
  reducers: {
    setLoadingData: (state, action) => {
      state.loading = action.payload
    },
    setMessageData: (state, action) => {
      state.message = action.payload
    },
    setIsLoggedInData: (state, action) => {
      state.isLoggedIn = action.payload
    },
    initFilters: (state, action) => {
      state.filters = {
        date: action.payload ? formatDate(action.payload.date) : formatDate(new Date()),
        searchField: "",
        restaurant: "ALL",
        period: "4",
        metrics: ["ALL"],
        alcohol_type: "All",
        giftCard_type: "All",
        rank: [],
        category: [],
        weeks: {
          label: "All",
          range: null,
          value: {
            start: null,
            end: null
          }
        },
        userType: "active_users",
        startDate2: "",
        endDate2: "",
        isCompare: false
      }
    },
    setInitDate: (state, action) => {
      state.filters.date = action.payload
    },
    setInitAlcoholType: (state, action) => {
      state.filters.alcohol_type = action.payload
    },
    setInitgiftCardType: (state, action) => {
      state.filters.giftCard_type = action.payload
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload
      }
    },
    setRestaurantList: (state, action) => {
      state.restaurantList = action.payload
    },
    setUserTypeList: (state, action) => {
      state.userTypeList = action.payload
    },
    setAdminUserList: (state, action) => {
      state.adminUsersList = action.payload
    },
    setRolesUserList: (state, action) => {
      state.roleUsers = action.payload
    },
    setNewRestaurantList: (state, action) => {
      state.newRestaurantList = action.payload
    },
    setSearchField: (state, action) => {
      state.filters.searchField = action.payload
    },
    setOrderBy: (state, action) => {
      state.filters.orderBy = action.payload
    },
    setIsUpdating: (state, action) => {
      state.isUpdating = action.payload
    },
    setIsMultiRestaurant: (state, action) => {
      state.isMultiRestaurant = action.payload
    },
    setUserType: (state, action) => {
      state.filters.userType = action.payload
    }
  }
})

export default app
export const appActions = app.actions
